<template>
  <v-container fluid>
    <v-row no-gutters dense>
      <v-col cols="6" class="box fl bg_green py-2 pr-1 pl-0">
        <v-card class="pa-2 d-flex flex-column">
          <v-card-text class="d-flex justify-center pt-2 px-1">출력전력</v-card-text>
          <v-card-text
            class="d-flex justify-center pa-0 font-weight-bold"
            style="color: var(--v-lightG-base);font-size: 2rem;"
          >{{unitedSolra.PVPCS_Pac}}</v-card-text>
          <v-card-text class="d-flex justify-center pa-0 pt-3 pb-2">kW</v-card-text>
          <!-- <span class="electory_title bold">출력전력 ▲</span> -->
          <!-- <span class="electory_count">
            <span class="big_txt bold">{{unitedSolra.PVPCS_Pac}}</span>kW
          </span>-->
        </v-card>
      </v-col>
      <v-col cols="6" class="box fr bg_blue py-2 pl-1 pr-0">
        <v-card class="pa-2 d-flex flex-column">
          <v-card-text class="d-flex justify-center pt-2 px-1">일누적발전량</v-card-text>
          <v-card-text
            class="d-flex justify-center pa-0"
            style="color: var(--v-aquaG-base);font-weight: bold;font-size: 2rem;"
          >{{unitedSolra.PVPCS_Daily_P}}</v-card-text>
          <v-card-text class="d-flex justify-center pa-0 pt-3 pb-2">kW/h</v-card-text>
          <!-- <span class="electory_title bold">일누적발전량</span>
          <span class="electory_count">
            <span class="big_txt bold">{{unitedSolra.PVPCS_Daily_P}}</span>kWh
          </span>-->
        </v-card>
      </v-col>
    </v-row>
    <v-card dense class="px-4 pt-2">
      <v-row class="br-btm-gray py-1" no-gutters dense>
        <v-col cols="6" class="d-flex align-center">당월예상 누적금액</v-col>
        <v-col cols="6" class="text-right">
          <font
            class="mr-1"
            style="color: var(--v-primary-base); font-size: 1.5rem;"
          >{{solraPrice.sumPrice}}</font>원
        </v-col>
      </v-row>
      <v-row
        v-if="solraPrice.isFit !== '1'"
        dense
        class="d-flex justify-space-between br-btm-gray py-1"
      >
        <v-col>REC</v-col>
        <v-col class="text-right">
          <font class="mr-1">{{solraPrice.recPrice}}</font>원
        </v-col>
      </v-row>
      <v-row
        v-if="solraPrice.isFit !== '1'"
        dense
        class="d-flex justify-space-between br-btm-gray py-1"
      >
        <v-col>SMP</v-col>
        <v-col class="text-right">
          <font class="mr-1">{{solraPrice.smpPrice}}</font>원
        </v-col>
      </v-row>
      <v-row v-show="solraPrice.isFit !== '1'" class="mt-1" dense no-gutters>
        <font
          size="2"
          color="gray"
        >＊ REC 단가({{solraPrice.rec/1000}}원), SMP단가({{solraPrice.smp}}원) 기준</font>
      </v-row>
      <v-row class="pb-2" dense no-gutters>
        <font size="2" color="gray">＊ 실제금액은 변동될 수 있습니다.</font>
      </v-row>
      <v-row class="br-btm-gray" dense no-gutters>
        <v-col class="d-flex justify-space-between" cols="6">
          <v-col cols="8" class="pr-0">가동수량</v-col>
          <v-col class="text-right" cols="4">
            <font size="4" style="color: var(--v-primary-base);">{{inverterRunCnt}}</font>
          </v-col>
        </v-col>
        <v-col class="d-flex justify-space-between" cols="6">
          <v-col cols="8" class="pr-0">설치수량</v-col>
          <v-col class="text-right" cols="4">
            <font size="4" style="color: var(--v-primary-base);">{{inverterSetCnt}}</font>
          </v-col>
        </v-col>
      </v-row>
      <v-row dense class="d-flex justify-space-between br-btm-gray py-1">
        <v-col class="d-flex align-center">당일 발전량</v-col>
        <v-col class="text-right">
          <font
            size="5"
            style="color: var(--v-primary-base);"
            class="mr-1"
          >{{unitedSolra.PVPCS_Daily_P}}</font>
          <font size="2" color="darkgray">kWh</font>
        </v-col>
      </v-row>
      <v-row dense class="d-flex justify-space-between br-btm-gray py-1">
        <v-col class="d-flex align-center">당일 발전시간</v-col>
        <v-col class="text-right">
          <font
            size="5"
            style="color: var(--v-primary-base);"
            class="mr-1"
          >{{unitedSolra.PVPCS_Day}}</font>
          <font size="2" color="darkgray">h</font>
        </v-col>
      </v-row>
      <v-row dense class="d-flex justify-space-between br-btm-gray py-1">
        <v-col class="d-flex align-center">전일 발전량</v-col>
        <v-col class="text-right">
          <font
            size="5"
            style="color: var(--v-primary-base);"
            class="mr-1"
          >{{ yesterdayData.PVPCS_Daily_P }}</font>
          <font size="2" color="darkgray">kWh</font>
        </v-col>
      </v-row>
      <v-row dense class="d-flex justify-space-between br-btm-gray py-1">
        <v-col class="d-flex align-center">전일 발전시간</v-col>
        <v-col class="text-right">
          <font
            size="5"
            style="color: var(--v-primary-base);"
            class="mr-1"
          >{{ yesterdayData.Daily_Time }}</font>
          <font size="2" color="darkgray">h</font>
        </v-col>
      </v-row>
      <v-row dense class="d-flex justify-space-between br-btm-gray py-1">
        <v-col class="d-flex align-center">당월 발전량</v-col>
        <v-col class="text-right">
          <font
            size="5"
            style="color: var(--v-primary-base);"
            class="mr-1"
          >{{unitedSolra.PVPCS_CurrentMonth_P}}</font>
          <font size="2" color="darkgray">kWh</font>
        </v-col>
      </v-row>
      <v-row dense class="d-flex justify-space-between br-btm-gray py-1">
        <v-col class="d-flex align-center">당월 발전시간</v-col>
        <v-col class="text-right">
          <font
            size="5"
            style="color: var(--v-primary-base);"
            class="mr-1"
          >{{unitedSolra.PVPCS_Month}}</font>
          <font size="2" color="darkgray">h</font>
        </v-col>
      </v-row>
      <v-row dense class="d-flex justify-space-between br-btm-gray py-1">
        <v-col class="d-flex align-center">전월 누적 발전량</v-col>
        <v-col class="text-right">
          <font
            size="5"
            style="color: var(--v-primary-base);"
            class="mr-1"
          >{{unitedSolra.PVPCS_AfterMonth_P}}</font>
          <font size="2" color="darkgray">kWh</font>
        </v-col>
      </v-row>
      <v-row dense class="d-flex justify-space-between py-1">
        <v-col class="d-flex align-center">총 누적 발전량</v-col>
        <v-col class="text-right">
          <font
            size="5"
            style="color: var(--v-primary-base);"
            class="mr-1"
          >{{unitedSolra.PVPCS_Total_P}}</font>
          <font size="2" color="darkgray">kWh</font>
        </v-col>
      </v-row>
      <v-row dense class="d-flex justify-space-between py-1">
        <v-col class="d-flex align-center">용량</v-col>
        <v-col class="text-right">
          <font
            size="5"
            style="color: var(--v-primary-base);"
            class="mr-1"
          >{{unitedSolra.PVPCS_Pcs_Capa}}</font>
          <font size="2" color="darkgray">kW</font>
        </v-col>
      </v-row>
    </v-card>
    <v-card dense class="px-4 pt-2 mt-2">
      <v-row class="align-center">
        <v-col cols="12" lg="12">
          <!-- <v-tabs v-model="tabNo" fixed-tabs>
            <v-tab>일 발전량</v-tab>
            <v-tab>월 발전량</v-tab>
            <v-tab>연 발전량</v-tab>
          </v-tabs>-->

          <v-row v-model="tabNo" class="runClass">
            <v-col
              class="pb-2 pa-4 tab_txt text-center"
              :class="{'on': tabNo === 0}"
              id="chart_tab_day"
              cols="4"
              v-on:click="solraWorkStateTab('day')"
            >일 발전량</v-col>
            <v-col
              class="pb-2 pa-4 tab_txt text-center"
              :class="{'on': tabNo === 1}"
              id="chart_tab_month"
              cols="4"
              v-on:click="solraWorkStateTab('month')"
            >월 발전량</v-col>
            <v-col
              class="pb-2 pa-4 tab_txt text-center"
              :class="{'on': tabNo === 2}"
              id="chart_tab_year"
              cols="4"
              v-on:click="solraWorkStateTab('year')"
            >연 발전량</v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="12">
        </v-col>
        <v-row class="d-flex pa-0" no-gutters>
          <v-col cols="6" class="pl-2">
            <span class="align-self-center mr-4" v-show="isDayWork">발전량 : {{dayWork}}</span>
          </v-col>
          <v-col class="d-flex justify-end" cols="6">
            <v-btn
              outlined
              small
              class="align-self-center excel_down mr-4"
              @click="excelDown"
            >엑셀 다운로드</v-btn>
          </v-col>
        </v-row>
        <v-row class="d-flex pa-0" no-gutters>
          <v-col cols="9" class="pa-2">
            <v-menu
              v-model="isSDateView"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="날짜"
                  outlined
                  v-model="startDate"
                  hide-details
                  readonly
                  dense
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="startDate" @input="isSDateView = false" no-title></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="3" class="d-flex justify-center align-center">
            <v-btn outlined small class="align-self-center default-btn" @click="searchGraph">조회</v-btn>
          </v-col>
        </v-row>
      </v-row>
      <v-row>
        <v-col cols="12" class="pa-0">
          <v-container class="pa-0" fluid>
            <v-chart autoresize style="width:100%;height: 200px;" :option="chartOption"></v-chart>
            <v-divider class="my-5"></v-divider>
            <real-grid
              ref="workStateDataGrid"
              class="mt-1 mb-5 w-full"
              :options="grid.gridOption"
              :fields="grid.gridFields"
              :columns="grid.gridColumns"
              :retrieve-api="gridRetrieveApi"
            ></real-grid>
          </v-container>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import DatePicker from '@/components/monitoring/DatePicker'
import {
  getSiteInfo,
  getSiteYesterday,
  getSolraUnitedWork,
  getSolraDayWork,
  getSolraMonthWork,
  getSolraYearWork,
  getSMPMonthAvgPrice // ,
  // getSolraUnitedInverterWork
} from '@/api/pcs/siteWork'
// import store from '@/store'
import { getMonitoringYesterDay } from '@/api/monitoring/monitoring.js'
import VChart, { THEME_KEY } from 'vue-echarts'
import RealGrid from '@/components/grid/Realgrid'
import day from 'dayjs'

import { CanvasRenderer } from 'echarts/renderers'
import { BarChart, LineChart } from 'echarts/charts'
import {
  DataZoomComponent,
  ToolboxComponent,
  GridComponent,
  VisualMapComponent,
  TimelineComponent,
  CalendarComponent,
  TooltipComponent,
  LegendComponent
} from 'echarts/components'
import { use } from 'echarts/core'
let intervalWorkState

use([
  CanvasRenderer,
  BarChart,
  LineChart,
  DataZoomComponent,
  ToolboxComponent,
  GridComponent,
  VisualMapComponent,
  TimelineComponent,
  CalendarComponent,
  TooltipComponent,
  LegendComponent
])

export default {
  props: {
    SITE_ID: { type: String, default: '' },
    INVERTER_ID: { type: String, default: '' },
    STATION_ID: { type: String, default: '' }
  },
  components: {
    RealGrid,
    VChart,
    DatePicker
  },
  destroyed() {
    this.stopTimer()
  },
  data() {
    return {
      tabIndex: 0,
      tempYesterdayData: [],
      updateUniteSolra: false,
      isSDateView: false,
      tabNo: 0,
      tempArr: [],
      smpPrice: 'aaaaa',
      inverterRunCnt: 0,
      inverterSetCnt: 0,
      timeWork: {},
      unitedSolra: {},
      solraPrice: {},
      tap_type: 'day',
      dayWork: 0.0,
      isDayWork: true,
      aChartOptions: createChartOption(),
      nowDate: this.$time(Date.now()).format('YYYY-MM-DD'),
      startDate: this.$time(Date.now()).format('YYYY-MM-DD'),
      endDate: this.$time(this.$time(Date.now()), 'YYYY-MM-DD'),
      chartTab: true,
      grid: {
        height: 442.5,
        gridOption: {
          gridView: {
            edit: {
              editable: false
            },
            setGroupingOptions: {
              enabled: false // header 그룹핑 옵션을 사용하지 않는다.
            },
            fixed: {
              rowCount: 1
            },
            checkBar: {
              visible: false
            },
            panel: {
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            },
            rowIndicator: {
              visible: false
            },
            stateBar: {
              visible: false
            }
          },
          dataProvider: {
            softDeleting: true,
            // 해당 옵션이 false 이면 추가된 행을 삭제했을 경우 -+ 표시가 생긴다.
            // true 이면 추가된 행은 바로 삭제, 기존에 존재하던 행은 - 표시
            deleteCreated: true
          }
        },
        gridTotal: 0,
        gridFields: [
          { fieldName: 'runTime', dataType: 'string' },
          { fieldName: 'runData', dataType: 'string' },
          { fieldName: 'runDataTotal', dataType: 'string' },
          { fieldName: 'runHour', dataType: 'string' },
          { fieldName: 'runHourTotal', dataType: 'string' }
        ],
        gridColumns: [
          {
            name: 'runTime',
            fieldName: 'runTime',
            header: {
              text: '시간'
            },
            styles: {
              textAlignment: 'center'
            },
            width: 50
          },
          {
            name: 'runData',
            fieldName: 'runData',
            header: {
              text: '발전량'
            },
            styles: {
              textAlignment: 'center',
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            },
            width: 50
          },
          {
            name: 'runDataTotal',
            fieldName: 'runDataTotal',
            header: {
              text: '누적 발전량'
            },
            styles: {
              textAlignment: 'center',
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            },
            width: 50
          },
          {
            name: 'runHour',
            fieldName: 'runHour',
            header: {
              text: '발전시간'
            },
            styles: {
              textAlignment: 'center',
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            },
            width: 50
          },
          {
            name: 'runHourTotal',
            fieldName: 'runHourTotal',
            header: {
              text: '누적 발전시간'
            },
            styles: {
              textAlignment: 'center',
              background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
            },
            width: 50
          }
        ]
      },
      tabValue: [
        {
          series: [
            '05:00',
            '05:20',
            '05:40',
            '06:00',
            '06:20',
            '06:40',
            '07:00',
            '07:20',
            '07:40',
            '08:00',
            '08:20',
            '08:40',
            '09:00',
            '09:20',
            '09:40',
            '10:00',
            '10:20',
            '10:40',
            '11:00',
            '11:20',
            '11:40',
            '12:00',
            '12:20',
            '12:40',
            '13:00',
            '13:20',
            '13:40',
            '14:00',
            '14:20',
            '14:40',
            '15:00',
            '15:20',
            '15:40',
            '16:00',
            '16:20',
            '16:40',
            '17:00',
            '17:20',
            '17:40',
            '18:00',
            '18:20',
            '18:40',
            '19:00',
            '19:20',
            '19:40',
            '20:00',
            '20:20',
            '20:40',
            '21:00',
            '21:20',
            '21:40'
          ]
        },
        {
          series: [
            '01일',
            '02일',
            '03일',
            '04일',
            '05일',
            '06일',
            '07일',
            '08일',
            '09일',
            '10일',
            '11일',
            '12일',
            '13일',
            '14일',
            '15일',
            '16일',
            '17일',
            '18일',
            '19일',
            '20일',
            '21일',
            '22일',
            '23일',
            '24일',
            '25일',
            '26일',
            '27일',
            '28일',
            '29일',
            '30일',
            '31일'
          ]
        },
        {
          series: [
            '1월',
            '2월',
            '3월',
            '4월',
            '5월',
            '6월',
            '7월',
            '8월',
            '9월',
            '10월',
            '11월',
            '12월'
          ]
        }
      ],
      barItems: [],
      bar: {
        xAxis: {
          type: 'category',
          data: ['a', 'b', 'c', 'd', 'e']
        },
        grid: {
          x: 35,
          y: 20,
          y2: 25,
          x2: 25
        },
        legend: {
          // data: ['발전량'],
          // right: '0',
          textStyle: {
            color: 'rgba(188, 188, 188, 1)'
          }
        },
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: function(value) {
                if (value >= 1000) {
                  return value / 1000 + 'k'
                }
                return value
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: 'rgba(204,204,204,0.5)'
              }
            }
          },
          {
            type: 'value',
            axisLabel: {
              formatter: '{value} h'
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: 'rgba(204,204,204,0.5)'
              }
            },
            minInterval: 1,
            maxInterval: 35
          }
        ],
        series: [
          {
            name: '발전량',
            data: [1, 2, 3, 4, 5],
            type: 'bar'
          }, {
            name: '발전시간',
            data: [1, 2, 3, 4, 5],
            yAxisIndex: 1,
            type: 'line'
          }
        ],
        tooltip: {
          trigger: 'axis'
        }
      }
    }
  },
  computed: {
    gridRetrieveApi() {
      return this.initChartData
    },
    chartOption() {
      let a = this.bar
      a.xAxis.data = this.tabValue[this.tabNo].series
      a.series[0].data = this.barItems
      a.series[1].data = this.lineItems
      return a
    },
    yesterdayData() {
      if (this.tempYesterdayData.length > 0) {
        let totalDP = 0
        let totalDT = 0
        for (let item of this.tempYesterdayData) {
          totalDP += item.PVPCS_Daily_P
        }
        // console.log(this.updateUniteSolra)
        // console.log(totalDP)
        if (this.updateUniteSolra) {
          return {
            PVPCS_Daily_P: totalDP.toFixed(1),
            Daily_Time: (
              totalDP /
              (this.unitedSolra.PVPCS_Pcs_Capa === undefined
                ? 1
                : this.unitedSolra.PVPCS_Pcs_Capa)
            ).toFixed(1)
          }
        } else {
          return {
            PVPCS_Daily_P: totalDP.toFixed(1),
            Daily_Time: 0
          }
        }
      } else {
        return {
          PVPCS_Daily_P: 0,
          Daily_Time: 0
        }
      }
    }
  },
  mounted: function() {
    this.tabIndex = 0
    window.scrollTo(0, 0)
    // console.log('0')
    this.getDataSiteInfo()
    this.stopTimer()
    this.initChartData()
    // this.getDatas()
    this.getYesterDayData()
    // 총누적발전시간 추가로 인버터 용량 정보 후 실행하기 위해 getSolraUnitedInverterWorkDate 내부로 이동
    // this.getSolraDayWorkTab()
  },
  watch: {
    SITE_ID(newValue) {
      getSiteYesterday(this.SITE_ID).then(res => {
        this.tempYesterdayData = res
      })
      this.initChart()
      this.initChartData()
      this.startTimer()
    },
    tabNo(newValue) {
      this.initChart()
      this.initChartData()
    },
    tabIndex(newValue) {
      this.startTimer()
      this.initChart()
      this.initChartData()
    }
  },
  methods: {
    // getDatas() {
    //   // let params = '?site_id=' + this.SITE_ID
    //   // getSMPMonthAvgPrice(params).then(res => {
    //   //  this.solraPrice = res
    //   // })

    //   if (this.tap_type === 'day') {
    //     this.getSolraDayWorkTab()
    //     this.isDayWork = true
    //   } else if (this.tap_type === 'month') {
    //     this.getSolraMonthWorkTab()
    //     this.isDayWork = false
    //   } else if (this.tap_type === 'year') {
    //     this.getSolraYearWorkTab()
    //     this.isDayWork = false
    //   } else if (this.tap_type === 'price') {
    //     this.getSolraPriceTab()
    //     this.isDayWork = false
    //   }
    // },
    getYesterDayData() {
      const _this = this
      // 전일 발전량이랑 전일 발전 시간 가져오기
      const params = this.$route.query.site_id
      getMonitoringYesterDay(params).then(res => {
        this.tempYesterdayData = res
      })
    },
    getDataSiteInfo() {
      // 2. site_id 로 사이트정보를 조회한다 (사이트 주소 및 인버터등)
      let params = '?site_id=' + this.SITE_ID
      getSiteInfo(params).then(res => {
        this.inverterSetCnt = res.SITE_INVERTER.length
        this.inverterRunCnt = res.SITE_INVERTER.filter(
          d => d.STATUS === 'Run' || d.STATUS === 'Stop'
        ).length
      })
    },
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
    initChart() {
      this.barItems = []
      this.lineItems = []
    },
    searchGraph() {
      this.$refs.workStateDataGrid.retrieve()
    },
    excelDown() {
      this.$refs.workStateDataGrid.excelDown(this.startDate)
    },
    initChartData() {
      if (this.tabIndex === 0) {
        let params = '?site_id=' + this.SITE_ID
        getSolraUnitedWork(params).then(res => {
          this.unitedSolra = res.unitedSiteInfo
          // this.solraPrice = res.smpInfo
          this.updateUniteSolra = true
          if (this.tabNo === 0) {
            this.getSolraDayWorkTabTotal()
            this.isDayWork = true
          } else if (this.tabNo === 1) {
            this.getSolraMonthWorkTabTotal()
            this.isDayWork = false
          } else if (this.tabNo === 2) {
            this.getSolraYearWorkTabTotal()
            this.isDayWork = false
          }
        })
        getSMPMonthAvgPrice(params).then(res => {
          this.solraPrice = res
        })
      } else {
        let params =
          '?site_id=' +
          this.SITE_ID +
          '&station_id=' +
          this.STATION_ID +
          '&inverter_id=' +
          this.INVERTER_ID
        getSolraUnitedWork(params).then(res => {
          this.unitedSolra = res.unitedSiteInfo
          // this.solraPrice = res.smpInfo
          // this.updateUniteSolra = true
          this.refreshFlag++
          if (this.tabNo === 0) {
            this.getSolraDayWorkTab()
            this.isDayWork = true
          } else if (this.tabNo === 1) {
            this.getSolraMonthWorkTab()
            this.isDayWork = false
          } else if (this.tabNo === 2) {
            this.getSolraYearWorkTab()
            this.isDayWork = false
          }
        })
      }
    },
    startTimer() {
      this.stopTimer()
      intervalWorkState = setInterval(() => {
        this.initChartData()
      }, 10000 * 2)
    },
    stopTimer() {
      if (intervalWorkState) {
        clearInterval(intervalWorkState)
      }
      intervalWorkState = null
    },
    getSolraDayWorkTab() {
      let params =
        '?site_id=' +
        this.SITE_ID +
        '&station_id=' +
        this.STATION_ID +
        '&inverter_id=' +
        this.INVERTER_ID +
        '&startDate=' +
        this.startDate
      getSolraDayWork(params).then(res => {
        // this.barItems = res.solraDayWork.runData

        // this.dayWork = res.solraDayWork.sumValData
        let datas = []
        let runDataTotal = 0
        let runData = 0
        let runTime = res.solraDayWork.runTime
        let runHourTotal = 0
        let runHour = 0
        let barData = []
        let lineHours = []
        let count = 0 // 0 아닌 데이터 카운트

        for (let index = 0; index < runTime.length; index++) {
          let runTimeRp = Number(runTime[index].replace(/:/gi, '')) // ex) 05:00 --> 0500
          barData.push(res.solraDayWork.runData[index].toFixed(1))
          runData += res.solraDayWork.runData[index] // 발전량
          runDataTotal += res.solraDayWork.runData[index] // 누적발전량
          lineHours.push((runData / this.unitedSolra.PVPCS_Pcs_Capa).toFixed(1))
          // ex) 05:50, 06:50 등 다음 시간으로 넘어가기 전 push
          // 20.02.06 AHJ 20분 간격으로 정책 변경에 따라 50->40으로 변경
          if (runTime[index].substr(3) === '40') {
            // 발전시간 추가
            if (runData.toFixed(1) > 0) {
              if (this.unitedSolra.PVPCS_Pcs_Capa === 0) {
                runHour = 0
                runHourTotal = 0
              } else {
                runHour = runData.toFixed(1) / this.unitedSolra.PVPCS_Pcs_Capa
                runHourTotal =
                  runDataTotal.toFixed(1) / this.unitedSolra.PVPCS_Pcs_Capa
                count++
              }
            } else if (runDataTotal.toFixed(1) > 0) {
              runHour = 0
              runHourTotal =
                runDataTotal.toFixed(1) / this.unitedSolra.PVPCS_Pcs_Capa
            } else {
              runHourTotal = 0
              runHour = 0
            }

            datas.push({
              runTime: runTime[index].substr(0, 2) + ':00',
              runData: runData.toFixed(1),
              runDataTotal:
                runData.toFixed(1) > 0 ||
                runTimeRp < day(Date.now()).format('HHmm')
                  ? runDataTotal.toFixed(1)
                  : '0.0',
              runHour: runHour.toFixed(1),
              // runHourTotal: runHourTotal.toFixed(1)
              runHourTotal:
                runData.toFixed(1) > 0 ||
                runTimeRp < day(Date.now()).format('HHmm')
                  ? runHourTotal.toFixed(1)
                  : '0.0'
            })
            runData = 0
          }
        }
        this.barItems = barData
        this.lineItems = lineHours
        // this.lineItems = []
        datas.unshift({
          runTime: '평균',
          runData: (runDataTotal / count).toFixed(1),
          runDataTotal: '-',
          runHour: (runHourTotal / count).toFixed(1),
          runHourTotal: '-'
        })
        this.dayWork = runDataTotal.toFixed(1)
        this.$refs.workStateDataGrid.getDataProvider().fillJsonData(datas)
      })
    },
    getSolraMonthWorkTab() {
      let params =
        '?site_id=' +
        this.SITE_ID +
        '&station_id=' +
        this.STATION_ID +
        '&inverter_id=' +
        this.INVERTER_ID +
        '&startDate=' +
        this.startDate
      getSolraMonthWork(params).then(res => {
        let runData = res.solraMonthWork.runData
        let runTime = res.solraMonthWork.runTime
        let datas = []
        let runDataTotal = 0
        let runHourTotal = 0
        let lineHours = []
        let barData = []
        let count = 0 // 0 아닌 데이터 카운트

        for (let i = 0; i < runData.length; i++) {
          runDataTotal = runData[i] + runDataTotal
          let iRunDataTotal = runData[i] > 0 ? runDataTotal : 0
          let irunHour = runData[i] / this.unitedSolra.PVPCS_Pcs_Capa
          runHourTotal = irunHour + runHourTotal
          let iRunHourTotal = runData[i] > 0 ? runHourTotal : 0
          lineHours.push(irunHour)
          barData.push(runData[i].toFixed(1))
          datas.push({
            runTime: runTime[i],
            runData: runData[i].toFixed(1),
            runDataTotal: iRunDataTotal.toFixed(1),
            runHour: irunHour.toFixed(1),
            runHourTotal: iRunHourTotal.toFixed(1)
          })
          if (runData[i] !== 0) {
            count++
          }
        }

        this.barItems = barData
        this.lineItems = lineHours

        datas.unshift({
          runTime: '평균',
          runData: (runDataTotal / count).toFixed(1),
          runDataTotal: '-',
          runHour: (runHourTotal / count).toFixed(1),
          runHourTotal: '-'
        })
        this.$refs.workStateDataGrid.getDataProvider().fillJsonData(datas)
      })
    },
    getSolraYearWorkTab() {
      let params =
        '?site_id=' +
        this.SITE_ID +
        '&station_id=' +
        this.STATION_ID +
        '&inverter_id=' +
        this.INVERTER_ID +
        '&startDate=' +
        this.startDate
      getSolraYearWork(params).then(res => {
        let runData = res.solraYearWork.runData
        let runTime = res.solraYearWork.runTime

        let datas = []
        let runDataTotal = 0
        let runHourTotal = 0
        let lineHours = []
        let barData = []
        let count = 0 // 0 아닌 데이터 카운트

        for (let i = 0; i < runData.length; i++) {
          runDataTotal = runData[i] + runDataTotal
          let iRunDataTotal = runData[i] > 0 ? runDataTotal : 0
          let irunHour = runData[i] / this.unitedSolra.PVPCS_Pcs_Capa
          runHourTotal = irunHour + runHourTotal
          let iRunHourTotal = runData[i] > 0 ? runHourTotal : 0
          lineHours.push(irunHour.toFixed(1))
          barData.push(runData[i].toFixed(1))
          datas.push({
            runTime: runTime[i],
            runData: runData[i].toFixed(1),
            runDataTotal: iRunDataTotal.toFixed(1),
            runHour: irunHour.toFixed(1),
            runHourTotal: iRunHourTotal.toFixed(1)
          })
          if (runData[i] !== 0) {
            count++
          }
        }

        this.barItems = barData
        this.lineItems = lineHours

        datas.unshift({
          runTime: '평균',
          runData: (runDataTotal / count).toFixed(1),
          runDataTotal: '-',
          runHour: (runHourTotal / count).toFixed(1),
          runHourTotal: '-'
        })
        this.$refs.workStateDataGrid.getDataProvider().fillJsonData(datas)
      })
    },
    getSolraDayWorkTabTotal() {
      let params = '?site_id=' + this.SITE_ID + '&startDate=' + this.startDate
      getSolraDayWork(params).then(res => {
        // this.barItems = res.solraDayWork.runData
        // this.dayWork = res.solraDayWork.sumValData

        let datas = []
        let runDataTotal = 0
        let runData = 0
        let runTime = res.solraDayWork.runTime
        let runHourTotal = 0
        let runHour = 0
        let lineHours = []
        let barData = []
        let count = 0 // 0 아닌 데이터 카운트

        for (let index = 0; index < runTime.length; index++) {
          let runTimeRp = Number(runTime[index].replace(/:/gi, '')) // ex) 05:00 --> 0500
          barData.push(res.solraDayWork.runData[index].toFixed(1))
          runData += res.solraDayWork.runData[index] // 발전량
          runDataTotal += res.solraDayWork.runData[index] // 누적발전량
          lineHours.push((runData / this.unitedSolra.PVPCS_Pcs_Capa).toFixed(1))

          // ex) 05:50, 06:50 등 다음 시간으로 넘어가기 전 push
          // 20.02.06 AHJ 40분 간격으로 변경함에 따라 50->40 변경
          if (runTime[index].substr(3) === '40') {
            // 발전시간 추가
            if (runData.toFixed(1) > 0) {
              if (this.unitedSolra.PVPCS_Pcs_Capa === 0) {
                runHour = 0
                runHourTotal = 0
              } else {
                runHour = runData.toFixed(1) / this.unitedSolra.PVPCS_Pcs_Capa
                // if (runHour === Infinity) {
                //   runHour = 0
                // }
                runHourTotal =
                  runDataTotal.toFixed(1) / this.unitedSolra.PVPCS_Pcs_Capa
                count++
              }
            } else if (runDataTotal.toFixed(1) > 0) {
              runHour = 0
              runHourTotal =
                runDataTotal.toFixed(1) / this.unitedSolra.PVPCS_Pcs_Capa
            } else {
              runHourTotal = 0
              runHour = 0
            }

            datas.push({
              runTime: runTime[index].substr(0, 2) + ':00',
              runData: runData.toFixed(1),
              runDataTotal:
                runData.toFixed(1) > 0 ||
                runTimeRp < day(Date.now()).format('HHmm')
                  ? runDataTotal.toFixed(1)
                  : '0.0',
              runHour: runHour.toFixed(1),
              // runHourTotal: runHourTotal.toFixed(1)
              runHourTotal:
                runData.toFixed(1) > 0 ||
                runTimeRp < day(Date.now()).format('HHmm')
                  ? runHourTotal.toFixed(1)
                  : '0.0'
            })
            runData = 0
          }
        }
        this.barItems = barData
        this.lineItems = lineHours
        datas.unshift({
          runTime: '평균',
          runData: (runDataTotal / count).toFixed(1),
          runDataTotal: '-',
          runHour: (runHourTotal / count).toFixed(1),
          runHourTotal: '-'
        })
        this.dayWork = runDataTotal.toFixed(1)
        this.$refs.workStateDataGrid.getDataProvider().fillJsonData(datas)
      })
    },
    getSolraMonthWorkTabTotal() {
      let params = '?site_id=' + this.SITE_ID + '&startDate=' + this.startDate
      getSolraMonthWork(params).then(res => {
        let runData = res.solraMonthWork.runData
        let runTime = res.solraMonthWork.runTime
        let datas = []
        let runDataTotal = 0
        let runHourTotal = 0
        let lineHours = []
        let barData = []
        let count = 0 // 0이 아닌 데이터 개수

        for (let i = 0; i < runData.length; i++) {
          runDataTotal = runData[i] + runDataTotal
          let iRunDataTotal = runData[i] > 0 ? runDataTotal : 0
          let irunHour = runData[i] / this.unitedSolra.PVPCS_Pcs_Capa
          runHourTotal = irunHour + runHourTotal
          let iRunHourTotal = runData[i] > 0 ? runHourTotal : 0
          lineHours.push(irunHour.toFixed(1))
          barData.push(runData[i].toFixed(1))
          datas.push({
            runTime: runTime[i],
            runData: runData[i].toFixed(1),
            runDataTotal: iRunDataTotal.toFixed(1),
            runHour: irunHour.toFixed(1),
            runHourTotal: iRunHourTotal.toFixed(1)
          })
          if (runData[i] !== 0) {
            count++
          }
        }

        this.barItems = barData
        this.lineItems = lineHours

        datas.unshift({
          runTime: '평균',
          runData: (runDataTotal / count).toFixed(1),
          runDataTotal: '-',
          runHour: (runHourTotal / count).toFixed(1),
          runHourTotal: '-'
        })
        this.$refs.workStateDataGrid.getDataProvider().fillJsonData(datas)
      })
    },
    getSolraYearWorkTabTotal() {
      let params = '?site_id=' + this.SITE_ID + '&startDate=' + this.startDate
      getSolraYearWork(params).then(res => {
        let runData = res.solraYearWork.runData
        let runTime = res.solraYearWork.runTime

        let datas = []
        let runDataTotal = 0
        let runHourTotal = 0
        let lineHours = []
        let barData = []
        let count = 0 // 0이 아닌 데이터 개수

        for (let i = 0; i < runData.length; i++) {
          runDataTotal = runData[i] + runDataTotal
          let iRunDataTotal = runData[i] > 0 ? runDataTotal : 0
          let irunHour = runData[i] / this.unitedSolra.PVPCS_Pcs_Capa
          runHourTotal = irunHour + runHourTotal
          let iRunHourTotal = runData[i] > 0 ? runHourTotal : 0
          lineHours.push(irunHour.toFixed(1))
          barData.push(runData[i].toFixed(1))
          datas.push({
            runTime: runTime[i],
            runData: runData[i].toFixed(1),
            runDataTotal: iRunDataTotal.toFixed(1),
            runHour: irunHour.toFixed(1),
            runHourTotal: iRunHourTotal.toFixed(1)
          })

          if (runData[i] !== 0) {
            count++
          }
        }

        this.barItems = barData
        this.lineItems = lineHours

        datas.unshift({
          runTime: '평균',
          runData: (runDataTotal / count).toFixed(1),
          runDataTotal: '-',
          runHour: (runHourTotal / count).toFixed(1),
          runHourTotal: '-'
        })
        this.$refs.workStateDataGrid.getDataProvider().fillJsonData(datas)
      })
    },
    solraWorkStateTab(type) {
      if (type === 'day') {
        this.getSolraDayWorkTab()
        this.tabNo = 0
        this.isDayWork = true
        this.bar.legend.data = ['발전량', '발전시간']
      } else if (type === 'month') {
        this.getSolraMonthWorkTab()
        this.tabNo = 1
        this.isDayWork = false
        this.bar.legend.data = ['발전량', '발전시간']
      } else if (type === 'year') {
        this.getSolraYearWorkTab()
        this.tabNo = 2
        this.isDayWork = false
        this.bar.legend.data = ['발전량', '발전시간']
      } else if (type === 'price') {
        this.getSolraPriceTab()
        this.isDayWork = false
        this.bar.legend.data = ['발전량', '발전시간']
      }
      this.tap_type = type
    }
  },
  created() {}
}

function createChartOption() {
  return {
    chart: {
      zoomType: 'xy',
      height: 340
    },
    title: {
      text: ''
    },
    tooltip: {
      enabled: true
    },
    yAxis: {
      title: {
        text: ''
      }
    },
    xAxis: {
      categories: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23'
      ]
    },
    series: [
      {
        type: 'column',
        showInLegend: false,
        data: [
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0
        ]
      },
      {
        type: 'spline',
        showInLegend: false,
        data: [
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0,
          0.0
        ]
      }
    ]
  }
}
</script>

<style scoped>
@import '../../../assets/mobile/site.less';
.el-input--mini .el-input__inner {
  height: 22px;
  line-height: 22px;
}
#realgrid {
  height: 332px;
  width: 100%;
  margin-top: 0;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
}
.br-btm-gray {
  border-bottom: 1px solid gray;
}
.runClass {
  height: 48px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 14px;
}
.tab_txt.on {
  color: var(--v-btnbg-base);
  background-color: var(--v-hpopbody-base);
  border-bottom: 2px solid var(--v-btnbg-base);
  transition: all 1s;
}
.tab_txt.text-center {
  font-size: 14px;
}
</style>
